import request from '@/utils/request';


export function optimizationAPI () {
    return {
        // 获取角色组列表
        getRuleList: params => {
            return request ({
                url: '/admin/rule/index',
                method: 'get',
                params,
            });
        },
        addAndEditRule: params => {
            return request ({
                url: '/admin/rule/update',
                method: 'post',
                data: params,
            });
        },
        addRule: params => {
            return request ({
                url: '/admin/rule/store',
                method: 'post',
                data: params,
            });
        },
        getRuleInfo: params => {
            return request ({
                url: `/admin/rule/show?id=${params}`,
                method: 'get',
            });
        },
        delRule: params => {
            return request ({
                url: `/admin/rule/delete`,
                method: 'post',
                data: params,
            });
        },
    };
}
